module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./OrderSwitchView.js"));
	}, "OrderSwitchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=OrderSwitchView!./src/pages/Shop/Member/TradeManage/OrderSwitch/OrderSwitchView.js
// module id = 1538
// module chunks = 418